<div mat-dialog-title fxLayoutAlign="space-between center">
  <div class="forge-typography--heading4">Notes</div>

  <div>
    @if (canAdd) {
      <forge-icon-button (click)="addNote()">
        <forge-tooltip placement="bottom">Add note</forge-tooltip>
        <forge-icon name="add"></forge-icon>
      </forge-icon-button>
    }
  </div>
</div>

<mat-dialog-content [formGroup]="formGroup" class="note-container">
  @if (isLoaded) {
    @if (isSingleNote) {
      <single-note [model]="note" [viewOnly]="viewOnly">
      </single-note>
    } @else {
      <notes [hideSubject]="hideSubject" [model]="notes" [viewOnly]="viewOnly" (delete)="onDelete($event)">
      </notes>
    }
  } @else {
    <busy-indicator [big]="true">
    </busy-indicator>
  }

  @if (isProcessing) {
    <busy-indicator [page]="true"></busy-indicator>
  }
</mat-dialog-content>

<mat-dialog-actions class="form-actions" align="end">
  <command-bar [commands]="commands"></command-bar>
</mat-dialog-actions>



